"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSortToListingOrderAndDir = void 0;
var DocumentSortEnum_1 = require("@/pages/document/states/DocumentSortEnum");
var ListOrderEnum_1 = require("@/pages/document/states/ListOrderEnum");
exports.DocumentSortToListingOrderAndDir = function (documentSort) {
    switch (documentSort) {
        case DocumentSortEnum_1.DocumentSortEnum.SORT_CREATE_DATE_ASC: return { listOrder: ListOrderEnum_1.ListOrderEnum.CREATED_DATE, isAsc: true };
        case DocumentSortEnum_1.DocumentSortEnum.SORT_CREATE_DATE_DESC: return { listOrder: ListOrderEnum_1.ListOrderEnum.CREATED_DATE, isAsc: false };
        case DocumentSortEnum_1.DocumentSortEnum.SORT_FORM_TYPE_ASC: return { listOrder: ListOrderEnum_1.ListOrderEnum.EFORM_TYPE, isAsc: true };
        case DocumentSortEnum_1.DocumentSortEnum.SORT_FORM_TYPE_DESC: return { listOrder: ListOrderEnum_1.ListOrderEnum.EFORM_TYPE, isAsc: false };
    }
    return { listOrder: ListOrderEnum_1.ListOrderEnum.CREATED_DATE, isAsc: false };
};
